import {
    GET_ALL_TESTIMONIALS
} from './constants';

const initialState = {
    allTestimonials: [],
    page: '',
    pages: '',
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL_TESTIMONIALS: {
            return {
                ...state,
                allTestimonials: action.payload.items,
                page: action.payload.page,
                pages: action.payload.pages,
            };
        }
        default:
            return state;
    }
};

